import type { AvatarProps as ChordsAvatarProps } from '~/chords/Avatar';
import { Avatar as ChordsAvatar } from '~/chords/Avatar';
import type { ContainerComponentProps } from '~/components/WithClassNameHoc';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export type AvatarProps = ContainerComponentProps<ChordsAvatarProps>;
export const Avatar = withClassNameHoc(ChordsAvatar);
